<template>
  <div
    v-bind:data-title="tooltipValue"
    data-toggle="tooltip"
    data-placement="top"
    class="add-player-button-container"
  >
    <button
      class="btn btn-default add-player-button"
      v-bind:disabled="disabled"
      v-on:click="$emit('addPlayer')"
    >
      {{ text }} <span class="glyphicon glyphicon-plus"></span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'add-player-button',
  props: ['overrideText', 'disabled'],
  computed: {
    text: function () {
      if (this.overrideText) {
        return this.overrideText;
      }

      return 'Add player';
    },
    tooltipValue: function () {
      // if (this.disabled) {
      //   return 'Disabled.';
      // }

      return ''; // disables the tooltip
    },
  },
  mounted: function () {
    if (process.env.NODE_ENV !== 'testing') {
      $(this.$el).tooltip();
    }
  },
};
</script>

<style lang="scss" scoped>
  .btn[disabled] {
    pointer-events: none;
  }

  .btn {
    width: 100%;
  }

  .glyphicon-plus {
    color: #333333ab;
  }
</style>



// WEBPACK FOOTER //
// src/components/controls/add-player-button.vue